import createModule from "../createModule"
import view from "./view"
import { Creators as ProfileCreators } from "model/profileModal"
import { getModel } from "./selectors/model"
import { Creators } from "./model"
import { get } from "lodash"
import { MODELS_QUERY, getModels } from "resources/models"

export default createModule({
  view,
  chromeGate: true,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "portfolios",
    as: null,
    url: ({ account }) => `/api/${account}/portfolios`,
  }, {
    ...MODELS_QUERY,
    as: null,
  }],
  mapStateToProps: (state, props) => ({
    security: state.modules.portfolioRoot.security,
    factorId: state.modules.portfolioRoot.factorId,
    model: getModel(state, props),
    header: get(state, "modules.homeLayout.header"),
    models: getModels(state, props),
    sessionExpired: get(state, "user.sessionExpired"),
  }),
  actions: {
    openSecurityProfile: ProfileCreators.openSecurityProfile2,
    closeSecurityProfile: ProfileCreators.closeSecurityProfile,
    closeFactorProfile: ProfileCreators.closeFactorProfile,
    ...Creators,
  },
})
